export const SUPPORT_LINK = 'https://www.dgree.tech';
